export default {
  payWelfareText: 'Top-up Benefits',
  blackFridayDiscount: 'Black Friday Timed Discount',
  shareGift: 'Share Gift',
  vipWeeklyWelfare: 'VIP Weekly Discount',
  exchangeCoupon: 'Coupon',
  firstPayOff: 'Up to 15% OFF for 1st Purchase',
  blackFridayEvent: 'Black Friday Event',
  limitedTimeOff: 'Limited Time 10% OFF',
  claimCoupon: 'Claim Now',
  blackFridayTimedCoupon: 'Black Friday Timed Coupon',
  timeLeft: 'Time left: ',
  claimTimeCoupon: 'Claim 10% OFF Coupon Now!',
  points: 'Points: ${point}',
  costPointTip: 'Exchange points for coupons',
  maxPointTip: 'Each account my use up to 500 points.',
  discountOff: '10% OFF',
  highestDiscount: 'Up to ${discount} OFF',
  needPoint: 'Requires ${point} pts',
  changeCurrency: 'Change Currency',
  claim: 'Claim',
  claimSucc: 'Claimed',
  claimFail: 'Failed',
  pointNotEnough: 'Insufficient points',
  afterClaimPoint: 'Points left: ${point}',
  footTips1: 'Only 1 coupon can be used for each order.',
  footTips2: 'Coupon cannot be used for purchasing in-game currencies/tokens.',
  footTips3:
    ' We reserve the right for the final interpretation of this event.',
  ruleTitleText: 'Event Rules',
  ruleTime: 'Event Duration: 00:00 Nov.24, 2023 to 23:59 Nov. 26, 2023 (UTC)',
  bfRuleText1:
    '1. 400 points will be granted to your account when you log in to the official top-up page for the first time during the event. You may exchange up to 500 points for coupons.',
  bfRuleText2:
    '2. You may exchange Black Friday points for the coupons during the event.',
  bfRuleText3:
    '3. You may only use 1 coupon for each order. Coupons cannot be used for purchasing in-game currencies/tokens.',
  bfRuleText4: '4. For transactions, we only accept the following currencies:',
  ableCoinsType:
    'USD, JPY, KRW, TWD, EUR, HKD, GBP, CAD, AUD, RUB, MYR, THB, PLN, IDR.',
  bfRuleText5:
    '5. You may not change the currency once a transaction is made. Exchanged points cannot be refunded.',
  bfRuleText6: '6. Black Friday coupons will only be valid for 7 days.',
  bfRuleText7:
    '7. We reserve the right for the final interpretation of this event.',
  thanksTip:
    'Thank you for your participation. Please join our official community for more event information.',
  exchangePoints: 'Exchange',
  exchangeCode: 'Enter exchange code.',
  enterExchangeCode: 'Please enter exchange code.',
  exchangeText: 'Exchange',
  confirmGet: 'Confirm',
  couponUsedWay:
    'Coupon can only be used with specific currencies, please confirm your currency.',
  confirmText: 'Confirm',
  exchangeSucc: 'Exchanged',
  aboutCoins: 'About In-game Currencies/Tokens',
  aboutCoinsText:
    'You may exchange in-game currencies/tokens for all packs and privileges except for the in-game currency/token itself.',
  known: 'OK',
  codeText: 'Code',
  codeInvalid: 'Code invalid!',
  hasExchanged: 'You may not claim more codes.',
  hideText: 'Hide',
  //黑五的报错码
  'bf-20001': 'Not logged in',
  'bf-20002': 'Parameter error. Please try re-entering the event.',
  'bf-20003': 'Insufficient points',
  'bf-20004': 'Failed! Please try again later or contact Customer Support.',
  'bf-20005': 'Claimed',
  'bf-20015': 'The event is currently not available.',
  'bf-20016': 'The event has ended.',
  bfShareText: 'Claim 10% OFF Coupon Now!',
  rightsCenterBtn: 'Premium Member Center',
  payBtn: 'TOP UP',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Glorious Extraordinaire (Permanent)',
  rightCenterNoticeTitle: 'VIP Point System Is Upgrading to the Privilege Center',
  rightCenterNoticeContent: 'Greetings, Commander!<br />Thank you for your supporting Puzzles & Survival. To bring you an even better rewards experience, the current VIP Point System will be upgraded to the all-new Premium Member Center on July 16, 2025. This new system will not only consolidate existing VIP benefits but also introduce a host of exciting new perks. Here\'s what you need to know:<br />1. What\'s Changing?<br />Weekly Log in Benefits Remain<br />From July 16 to 29, 2025, players can continue to claim Weekly VIP Coupons by logging in to the Official Top-up Page. The number of coupons will remain the same as in the VIP Point event. Meanwhile, players will also be able to redeem new coupons in the Premium Member Center, which will include a maximum discount cap. For more details on the new coupon rules and redemption limits, refer to the table at the end of this notice.<br />Note: The automatic coupon redemption feature must be manually enabled. To do so, go to: Privilege Center Homepage > Member Benefits > Enable Auto Redeem Coupons > Select Coupons to Auto-Redeem > Confirm.<br />New Points Exchange Feature<br />The Privilege Center will offer a Points Exchange feature. Earn points by logging in to the game or completing designated tasks. Points can be exchanged for exclusive coupons, rare items, and other valuable rewards. (See the Privilege Center page for item redemption limits.)<br />VIP Level Inheritance<br />Your current VIP level and accumulated VIP Points will be fully transferred to the new system. You\'ll automatically be assigned the corresponding Privilege Center tier, and all your current VIP benefits will be retained and further enhanced under the new system.<br />2. Why This Upgrade Is Better<br />Clearer Benefits: All reward rules and redemption details are clearly displayed, making it easier to claim your benefits.<br />Greater Rewards: Enjoy new point exchange events and regularly updated high-value items.<br />Lucky Draws: In addition to points exchange, prize draw events will also be available, giving you chances to win valuable in-game items.<br />3. Important Notes<br />During the transition period (July 16 to 29, 2025), the original VIP Points section will be gradually phased out. You will still be able to receive and use coupons as usual during this time. Be sure to use any remaining coupons before the VIP Points Event ends. Unused coupons will expire.<br />After the Privilege Center goes live, you can access it by going to Official Top-up Center > Tap Avatar > Privilege Center',
  rightCenterNoticeTableTitle: 'Coupon Changes Comparison',
  rightCenterNoticeTableHeader1: 'Redemption Requirements - Premium Membership Level',
  rightCenterNoticeTableHeader2: 'Original VIP Level',
  rightCenterNoticeTableHeader3: 'Coupon Discount',
  rightCenterNoticeTableHeader4: 'Acquisition Limit',
  rightCenterNoticeTableHeader5: 'Max Discount Cap',
  rightCenterNoticeTableLevel1: 'Bronze',
  rightCenterNoticeTableLevel2: 'Silver',
  rightCenterNoticeTableLevel3: 'Gold',
  rightCenterNoticeTableLevel4: 'Platinum',
  rightCenterNoticeTableLevel5: 'Diamond',
  rightCenterNoticeTableCount1: 'Once Daily',
  rightCenterNoticeTableCount2: '15 per Month',
  rightCenterNoticeTableCount3: '10 per Month',
  rightCenterNoticeTableLimit: 'US$15',
  rightCenterNoticeTableTip: 'Note: Coupon discount caps in the Privilege Center are based on USD and may fluctuate with exchange rates. The actual discount amount will be displayed on the usage page.',
  '-': '-'
};
